// SWRegistrar — registra el service worker al cargar la app (Sprint 9).
//
// - Solo en producción (no en dev para no cachear bundles).
// - Maneja updates: si hay un SW nuevo, dispara un evento
//   `sw-update-available` que el componente de UI puede capturar
//   para mostrar un toast "Nueva versión disponible, recargá".

import { useEffect } from 'react';

export function SWRegistrar(): null {
  useEffect(() => {
    if (typeof navigator === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    if (!import.meta.env.PROD) return;

    const onUpdate = (): void => {
      console.info('[SW] update available');
      window.dispatchEvent(new CustomEvent('sw-update-available'));
    };

    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              onUpdate();
            }
          });
        });
      })
      .catch((err: unknown) => {
        console.warn('[SW] register failed:', err);
      })
      .finally(() => undefined);
  }, []);

  return null;
}
